module.exports = __webpack_public_path__ + "img/icon_tab4.fc22ebd7.png";